<app-nav [navItems]="navItems" />
<div class="static">
  <h1>ImageBase.pro</h1>
  <p>
    Welcome to <strong>ImageBase.pro</strong>, a premium photostock by Digital
    DP LTD (Company Number: 15914437), where quality and professionalism come
    first.
  </p>
  <p>
    We offer both paid and free photographs across a variety of themes, all
    carefully created by our in-house team or commissioned from professional
    photographers. Unlike most stock photo platforms that merely serve as
    intermediaries for user-generated content, we control every stage of the
    creation and curation process. This ensures that you receive only top-notch
    visuals for your projects.
  </p>
  <h2>Why Choose ImageBase.pro?</h2>
  <ul>
    <li>
      <strong>Top-Quality Content.</strong> Each photo is manually created or
      curated to meet the highest professional standards.
    </li>
    <li>
      <strong>Access to Original Formats.</strong> We provide downloads in RAW
      format, making it perfect for designers, photographers, and anyone who
      values flexibility in editing.
    </li>
    <li>
      <strong>Versatility for All Users.</strong> Whether you’re a beginner, a
      seasoned professional, or a business representative, we offer everything
      you need to inspire and execute your ideas.
    </li>
  </ul>
  <p>
    We take pride in offering a convenient, reliable, and high-quality service
    for working with photos. Join ImageBase.pro to always have access to images
    that make your projects unforgettable.
  </p>
  <p>
    Your trusted partner in visual content, <strong>DIGITAL DP LTD</strong>.
  </p>
</div>
